// import Divider from 'components/common/Divider';
import PropTypes from 'prop-types';
import React, { useState, useContext } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
// import SocialAuthButtons from './SocialAuthButtons';
import { useTranslation, Trans } from 'react-i18next';
import { login } from 'y4/Falcon';
import { getQuery } from 'y4/Utils';
import DataContext from 'y4/context/DataContext';
import AppContext from 'context/Context';

const LoginForm = ({ hasLabel, layout }) => {
  const { t } = useTranslation('auth');
  const location = useLocation();
  const {
    config: { team, corp }
  } = useContext(AppContext);

  const from = getQuery(location.search, 'from');
  const user = getQuery(location.search, 'user');
  const type = getQuery(location.search, 'type');

  // State
  const [formData, setFormData] = useState({
    email: user,
    password: '',
    remember: false
  });

  const { setGlobalData } = useContext(DataContext);
  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    login(
      team,
      corp,
      type,
      formData.email,
      formData.password,
      formData.remember,
      from,
      setGlobalData,
      t
    );
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && (
          <Form.Label>
            <Trans ns="auth">Email address</Trans>
          </Form.Label>
        )}
        <Form.Control
          placeholder={!hasLabel ? t('Email address') : ''}
          value={formData.email || ''}
          name="email"
          onChange={handleFieldChange}
          type={process.env.REACT_APP_ACCOUNT_TYPE}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && (
          <Form.Label>
            {type === 'verification' ? (
              <Trans ns="auth">Verification code</Trans>
            ) : (
              <Trans ns="auth">Password</Trans>
            )}
          </Form.Label>
        )}
        <Form.Control
          placeholder={!hasLabel ? t('Password') : ''}
          value={formData.password || ''}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0 d-none">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              <Trans ns="auth">Remember me</Trans>
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/${corp}/authentication/${layout}/forgot-password?user=${
              formData.email || ''
            }`}
          >
            {t('Forgot Password?')}
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password}
        >
          <Trans ns="auth">Log in</Trans>
        </Button>
      </Form.Group>
      {/**
      <Divider className="mt-4">
        <Trans ns="auth">or log in with</Trans>
      </Divider>

      <SocialAuthButtons />

       */}
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
